import React from "react";

import { BriefLoader } from "../../../../components/brief/BriefLoader";
import { BriefType } from "../../../../constants/types";
import { BriefWrapper } from "../../../../components/brief/brief-wrapper/brief-wrapper.component";
import { DuplicateCampaignBriefModal } from "../../../../components/modals/duplicate-campaign-brief-modal/components/duplicate-campaign-brief-modal/duplicate-campaign-brief-modal.component";
import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";

import { CampaignBriefFormComponent } from "../campaign-brief-form/campaign-brief-form.component";

import { CampaignBriefViewProps } from "./campaign-brief-view.props";

export const CampaignBriefViewComponent = withShowIf((props: CampaignBriefViewProps) => (
  <>
    <BriefLoader showIf={!Boolean(props.brief.id)} />
    <BriefWrapper
      showIf={Boolean(props.brief.id)}
      briefId={props.brief.id}
      briefType={BriefType.CAMPAIGN_BRIEF}
      ContentComponent={CampaignBriefFormComponent}
      attachedFiles={props.attachedFiles}
      defaultValues={props.defaultValues}
      extraActions={props.extraActions}
      formErrors={props.formErrors}
      isLoading={props.isLoading}
      isSaving={props.isSaving}
      name={props.brief.name}
      ndaData={props.ndaData}
      onSubmit={props.onSubmit}
      onDeleteFile={props.onDeleteFile}
      onUploadFile={props.onUploadFile}
      owner={props.briefOwnerName}
      setIsSaving={props.setIsSaving}
      stateErrors={props.errors}
      status={props.brief.status}
      template={props.brief.resourcetype}
      updatedTime={props.brief.updatedAt}
      validationSchema={props.validationSchema}
      onChangeName={props.onChangeName}
    />
    <DuplicateCampaignBriefModal
      errors={props.errors}
      id={props.brief.id}
      isOpen={props.isDuplicateModalOpen}
      onClose={() => props.setDuplicateModalOpen(false)}
      onSubmit={props.onDuplicateBrief}
    />
  </>
));
